<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'settings.billing.monthlyLicensePurchase.title' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <div class="form">
      <div class="price-summary" *ngIf="calculatedPrice > 0">
        <div class="price-row">
          <div class="price-row-content">
            <div class="price-row-header">
              <span class="price-label">{{ 'settings.billing.monthlyLicensePurchase.proportionalPrice' | translate }}:</span>
              <span class="price-value">{{ proportionalPrice | number:'1.2-2' }} {{ data.currency }}</span>
            </div>
            <div class="price-info">
              {{ 'settings.billing.monthlyLicensePurchase.priceInfo' | translate }}
            </div>
          </div>
        </div>
        <div class="price-details">
          <div class="price-detail-item">
            <div class="price-detail-row">
              <span>{{ 'settings.billing.monthlyLicensePurchase.numberOfLicenses' | translate }}:</span>
              <span>{{ employeeCount }}</span>
            </div>
            <div class="disclaimer-inline">
              {{ 'settings.billing.monthlyLicensePurchase.disclaimer' | translate }}
            </div>
          </div>
          <div class="price-detail-row">
            <span>{{ 'settings.billing.monthlyLicensePurchase.fullMonthPrice' | translate }}:</span>
            <span>{{ fullMonthPrice | number:'1.2-2' }} {{ data.currency }}</span>
          </div>
          <div class="price-detail-item">
            <div class="price-detail-row">
              <span>{{ 'settings.billing.monthlyLicensePurchase.daysRemaining' | translate }}:</span>
              <span>{{ daysRemaining }} / {{ daysInMonth }}</span>
            </div>
            <div class="price-note-inline">
              {{ 'settings.billing.monthlyLicensePurchase.priceNote' | translate }}
            </div>
          </div>
        </div>
        <div class="price-note">
          <div class="next-payment-info">
            {{ 'settings.billing.monthlyLicensePurchase.nextPaymentDate' | translate }}: {{ nextPaymentDate | date:'dd.MM.yyyy' }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()">{{ 'cancel' | translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="submit()" [disabled]="sendingRequest">
      {{ sendingRequest ? ('saving' | translate) : ('settings.billing.monthlyLicensePurchase.proceed' | translate) }}
    </button>
  </footer>
</div>
